import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import VeteransJobTrainingDetails from '../../subdepartmentdetails/VeteransJobTraining'


function VeteransJobTraining() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Employment and Job Training Programs for Veterans || Veterans Affairs";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Veterans Affairs"
            title="Veterans Employment Support & Job Training"
            subtitledown="Department of Veterans Affairs"
           />
            <VeteransJobTrainingDetails/>
        </div>
    </>
  )
}

export default VeteransJobTraining